import customAxios from '../../customAxios';
import { ADMIN_SEND_2_BANK_MANY_WITHDRAWAL_COMPANIES } from '../../routes';

const sendToBankManyPay2Company = async (ids: Array<string>): Promise<any> => {
  try {
    return (await customAxios.put(ADMIN_SEND_2_BANK_MANY_WITHDRAWAL_COMPANIES, {withdrawalsId: ids})).data;
  } catch (error: unknown) {
    return console.error({ADMIN_SEND_2_BANK_MANY_WITHDRAWAL_COMPANIES: error});
  }
};

export default sendToBankManyPay2Company;
